const SEMANTIC_COLORS = {
  RED: 'red',
  GREEN: 'green',
  BLUE: 'blue',
  YELLOW: 'yellow',
  OLIVE: 'olive',
  TEAL: 'teal',
};

export default SEMANTIC_COLORS;
